import React, { useState, useEffect, useCallback } from "react";
import { APIClient } from "../../../utils/APIClient";
import { API_URL } from "../../../settings/local_settings";
import { ClientHeader } from "../ClientHeader";
import { ClientTabs } from "../ClientTabs";
import { UnifiedAgentSidebar } from "../../agent/shared/UnifiedAgentSidebar";
import { AgentSessionProvider } from "../../agent/shared/AgentSessionContext";
import { ClientAgentChat } from "./ClientAgentChat";
import { SectionIntro } from "../../elements/SectionIntro";
import { useTranslation } from "react-i18next";


export const ClientAgentContent = ({ clientId, sessionId }) => {
    const { t } = useTranslation();
    const [name, setName] = useState('');
    const [businessUnits, setBusinessUnits] = useState(null);
    const [clientAdAccounts, setClientAdAccounts] = useState(null);
    const [chatKey, setChatKey] = useState(0);

    const handleNewChat = useCallback(() => {
        setChatKey(k => k + 1);
    }, []);

    const fetchClientData = useCallback(() => {
        new APIClient(API_URL + 'client/' + clientId).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                setName(data.data.name);
                setBusinessUnits(data.data.business_units || []);
                setClientAdAccounts(data.data.client_ad_accounts || []);
            }
        });
    }, [clientId]);

    useEffect(() => {
        fetchClientData();
    }, [fetchClientData]);

    const handleSessionCreated = useCallback(() => {
        // El contexto refresca automáticamente al cambiar activeSessionId
    }, []);

    const handleSessionNameUpdate = useCallback(() => {
        // Manejado por el contexto
    }, []);

    return (
        <section className="section-content agent-area-wrapper client-workspace-page">
            <ClientHeader name={name} />
            <ClientTabs clientId={clientId} />

            <div className="section-body client-workspace-body">
                <SectionIntro
                    kicker={t('client_sections.agent.kicker')}
                    title={t('client_sections.agent.title')}
                    description={t('client_sections.agent.description')}
                />
            </div>

            <AgentSessionProvider entryPoint="client" clientId={clientId} activeSessionId={sessionId}>
                <div className="agent-area">
                    <UnifiedAgentSidebar onNewChat={handleNewChat} />
                    <ClientAgentChat
                        key={chatKey}
                        clientId={clientId}
                        sessionId={sessionId}
                        onSessionCreated={handleSessionCreated}
                        onSessionNameUpdate={handleSessionNameUpdate}
                        adAccounts={clientAdAccounts}
                        businessUnits={businessUnits}
                    />
                </div>
            </AgentSessionProvider>
        </section>
    );
};
